export const INTERESTS = [
  { value: "demo", label: "Request a demo" },
  { value: "general", label: "General inquiry" },
  { value: "webinar", label: "Private webinar" },
];

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function validateContact(values) {
  const errors = {};
  if (!String(values.name || "").trim()) errors.name = "Please enter your name.";
  if (!EMAIL.test(String(values.email || "").trim()))
    errors.email = "Please enter a valid email address.";
  const digits = String(values.phone || "").replace(/\D/g, "");
  if (digits.length > 0 && digits.length < 7)
    errors.phone = "Please enter a complete phone number, or leave it blank.";
  if (!INTERESTS.some((i) => i.value === values.interest))
    errors.interest = "Please choose what you are interested in.";
  if (String(values.message || "").trim().length < 10)
    errors.message = "Please tell us a little more (at least 10 characters).";
  return { valid: Object.keys(errors).length === 0, errors };
}
